//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import Filters from '~/components/filters/Index.vue';
import TextField from '~/components/ui/TextField.vue';
import DateRange from '~/components/ui/DateRange.vue';

export default {

  components: {
    Filters,
    TextField,
    DateRange,
  },
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        text: '',
        dateCreatedFrom: '',
        dateCreatedTo: '',
      },
    };
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('userPrivateChats', ['setFilters']),
  },
};
